export const SUPPORT_EMAIL = 'support@chainalysis.com'
export const MIN_PASSWORD_LENGTH = 15
export const TERMS_OF_SERVICE_LINK =
  'https://go.chainalysis.com/rs/503-FAP-074/images/Terms%20%26%20Conditions%20-%20All%20Training%20_%20Combined%20%28Nov%2019%2C%202020%29.pdf'
export const PRIVACY_POLICY_LINK = 'https://www.chainalysis.com/privacy-policy/'
